import { Component, inject, input } from '@angular/core';
import { Step } from './stepper.model';
import { StepperService } from './stepper.service';
import { map, Observable } from 'rxjs';
import { DecisionEnum } from '../application/data-transmission/data-transmission.model';
import { ApplicationStore } from '../application/application-store.service';
import { RouterLink } from '@angular/router';
import { AsyncPipe, LowerCasePipe, NgClass } from '@angular/common';
import { NoValue } from '@tribeauto/ngx-mobilite-material';
import { StepComponent } from '../../graphic/atom/step/step.component';
import { MatButton } from '@angular/material/button';
import { DecisionComponent } from '../decision/decision.component';
import { isCreditModerne } from '../helpers/society.helper';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'fol-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss'],
  imports: [RouterLink, AsyncPipe, LowerCasePipe, NgClass, StepComponent, MatButton, DecisionComponent, TranslatePipe]
})
export class StepperComponent {
  private readonly stepperService: StepperService = inject(StepperService);
  private readonly applicationStore: ApplicationStore = inject(ApplicationStore);

  decision = input<DecisionEnum | NoValue>(null);

  isApplicationState = false;
  isSignatureState = false;
  isSupportingDocumentsState = false;
  isFinalState = false;
  pointOfSale = this.applicationStore.instant('pointOfSale');
  isCreditModerne = isCreditModerne(this.pointOfSale?.societyCode);

  state$: Observable<Step> = this.stepperService.activeStep.pipe(
    map(workflow => {
      const activeStep = workflow.activeStep;
      this.isApplicationState = activeStep === Step.APPLICATION;
      this.isSignatureState = activeStep === Step.SIGNATURE;
      this.isSupportingDocumentsState = activeStep === Step.SUPPORTING_DOCUMENTS;
      this.isFinalState = activeStep === Step.FINAL;
      return activeStep;
    })
  );

  steps: Step[] = this.isCreditModerne
    ? [Step.APPLICATION, Step.COUNSELOR_RECONTACT]
    : Object.values(Step).filter(step => step !== Step.FINAL && step !== Step.COUNSELOR_RECONTACT);
  validatedSteps = this.stepperService.getValidatedSteps();
}
